import React from "react";
import { Location } from "history";
import { useTranslation } from "react-i18next";
import { InvitationApi } from "../../../../services/Api/Organization/organizationTypes";
import RegisterForInvitationForm from "../../components/RegisterForInvitationForm";
import RegisterLayout from "../../components/RegisterLayout";

interface Props {
	invitation: InvitationApi;
	acceptationCode: string | null;
	location: Location;
}

const NoUserInvitation = ({ invitation, acceptationCode, location }: Props) => {
	const { t } = useTranslation();

	return (
		<RegisterLayout>
			<p>
				{t("modules.security.field.invited.title")}
				<strong> {invitation.organization.name}</strong>.{" "}
				{t("modules.security.field.register_to_continue.title")}
			</p>
			<RegisterForInvitationForm
				email={invitation.email}
				acceptationCode={acceptationCode ?? ""}
				location={location}
			/>
		</RegisterLayout>
	);
};

export default NoUserInvitation;
